





































import axios from 'axios'
import { Component, Prop, Vue } from 'vue-property-decorator'
import GitHubIcon from '@/components/icons/urls/GitHubIcon.vue'
import GitLabIcon from '@/components/icons/urls/GitLabIcon.vue'
import MainIcon from '@/components/icons/urls/MainIcon.vue'

@Component({
  components: {
    GitHubIcon,
    GitLabIcon,
    MainIcon
  }
})
export default class ProjectCard extends Vue {
  @Prop(String) readonly name!: string

  info: { 'main'?: string, 'name': string, 'description': string, 'image': string, 'developer': { 'name': string, 'www': string }, 'urls'?: { 'main'?: string, 'gitlab'?: string, 'github'?: string } } | undefined
  errors: object[] = []

  data () {
    return {
      info: undefined
    }
  }

  async created () {
    try {
      const response = await axios.get(this.name + '/project-info/info.json')
      this.info = response.data
    } catch (e) {
      this.errors.push(e)
      this.info = undefined
    }
  }
}
